import { EXPENSES_TYPES } from '@/lib/constants/expensesTypes'

let getExpenseTypeLabel = (expenseTypeId) => {
  return EXPENSES_TYPES[expenseTypeId]
}

export default getExpenseTypeLabel
